// extracted by mini-css-extract-plugin
export default {"dark":"SuccessLinked_dark__TDoBD","App":"SuccessLinked_App__N+Xad","container":"SuccessLinked_container__vHMR1"};